import React from "react";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./App.scss";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/redux/store/store";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
